import { EditorState, Modifier } from 'wix-rich-content-editor-common';
import strategy from './strategy';
import { SelectionState } from '@wix/draft-js';
// Marks the ranges where emote codes are as entities so that backspace etc works
export default function attachImmutableEntitiesToEmotes(editorState) {
    const contentState = editorState.getCurrentContent();
    const blocks = contentState.getBlockMap();
    let newContentState = contentState;
    blocks.forEach((block)=>{
        if (!block) {
            return;
        }
        const plainText = block.getText();
        const addEntityToEmote = (start, end)=>{
            const existingEntityKey = block.getEntityAt(start);
            if (existingEntityKey) {
                // avoid manipulation in case the emote already has an entity
                const entity = newContentState.getEntity(existingEntityKey);
                if (entity && entity.getType() === 'DA_OFF_EMOTE') {
                    return;
                }
            }
            const selection = SelectionState.createEmpty(block.getKey()).set('anchorOffset', start).set('focusOffset', end);
            const emoteText = plainText.substring(start, end);
            const contentStateWithEntity = newContentState.createEntity('DA_OFF_EMOTE', 'IMMUTABLE', {
                emote: emoteText
            });
            const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
            newContentState = Modifier.replaceText(newContentState, selection, emoteText, undefined, entityKey);
            // Add a space if we are at the end of the block
            const blockKey = selection.getAnchorKey();
            const blockSize = editorState.getCurrentContent().getBlockForKey(blockKey).getLength();
            if (blockSize === end) {
                newContentState = Modifier.insertText(newContentState, newContentState.getSelectionAfter(), ' ');
            }
        };
        strategy(block, addEntityToEmote);
    });
    if (!newContentState.equals(contentState)) {
        return EditorState.push(editorState, newContentState, 'change-block-data');
    }
    return editorState;
}
